

// src/app/login/page.tsx
'use client';

import { ReportesPage } from '../../sections/reportes/ReportesPage';



export default function ReportesPages() {
  return <ReportesPage />;
}